// @noflow
import acquireDevices from './acquire-devices';
import actions from './actions';
import alerts from './alerts';
import application from './application';
import appSettings from './app-settings';
import audioPlayer from './ui/sensor-logs/audio-player/';
import authentication from './authentication';
import bulbsUi from './ui/bulbs';
import { combineReducers } from 'redux';
import config from './config';
import connectedCareInvite from './connected-care-invite';
import contactSensor from './products/contact-sensor';
import cookies from './cookies';
import dashboard from './dashboard';
import devices from './devices';
import entitlements from './entitlements';
import form from './form';
import groups from './groups';
import homes from './homes';
import holidayMode from './holiday-mode';
import hub from './hub';
import leakSensor from './products/leak-sensor';
import { ResetState } from '~/core/state/application/actions';
import menu from './menu';
import { merge } from 'lodash/fp';
import motionSensor from './products/motion-sensor';
import installNano1Upgrade from './install-nano1-upgrade';
import hueBridgeInstallation from './install-hue-bridge';
import navigate from './navigate';
import notifications from './notifications';
import powerConsumption from './power-consumption';
import products from './products';
import recipes from './recipes';
import schedules2 from './ui/schedule';
import sense from './products/sense/';
import settingsModal from './settings-modal';
import textControl from './text-control';
import translations from './translations';
import user from './user';
import weather from './weather';
import serviceOutage from './service-outage';

const getSyncReducers = () => ({
    acquireDevices,
    actions,
    alerts,
    application,
    appSettings,
    audioPlayer,
    authentication,
    bulbsUi,
    config,
    connectedCareInvite,
    contactSensor,
    cookies,
    dashboard,
    devices,
    entitlements,
    form,
    groups,
    homes,
    holidayMode,
    hub,
    hueBridgeInstallation,
    leakSensor,
    menu,
    motionSensor,
    installNano1Upgrade,
    navigate,
    notifications,
    powerConsumption,
    products,
    recipes,
    schedules2,
    sense,
    serviceOutage,
    settingsModal,
    textControl,
    translations,
    user,
    weather
});

const combineReducersWithAsync = (asyncReducers = {}) => {
    const syncReducers = getSyncReducers();
    const asyncKeys = Object.keys(asyncReducers);

    const asyncAndComposedDuplicateReducers = asyncKeys.reduce((agg, key) => {
        const asyncReducer = asyncReducers[key];
        const syncReducer = syncReducers[key];

        const { reduce = asyncReducer } = asyncReducer;

        // If a sync reducer already exists for this branch,
        // and the asyncReducer identifies itself as being mergable,
        // compose the new async one with the sync one.
        const nextReducer =
            syncReducer && asyncReducer.mergable
                ? (state, action) => {
                      // If we know the state is null/undefined we know that each reducer
                      // will return a `defaultState` object.
                      // For this reason we can't simply compose the calls because sync(state) will return a defaultState
                      // and async(defaultSyncState) will receive it, thus not returning it's own defaultState.
                      // Let's call them separately and merge the two defaultStates together.
                      if (state === null || state === undefined) {
                          const syncDefaultState = syncReducer(state, action);
                          const asyncDefaultState = reduce(state, action);
                          return merge(syncDefaultState, asyncDefaultState);
                      }

                      return reduce(syncReducer(state, action), action);
                  }
                : reduce;

        return {
            ...agg,
            [key]: nextReducer
        };
    }, {});

    return combineReducers({
        ...syncReducers,
        ...asyncAndComposedDuplicateReducers
    });
};

export default function createReducer(asyncReducers) {
    const combinedReducers = combineReducersWithAsync(asyncReducers);
    return (state = {}, action) => {
        if (action.type === ResetState.toString()) {
            state = undefined;
        }

        return combinedReducers(state, action);
    };
}



// WEBPACK FOOTER //
// ./src/core/state/index.js